import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsCommon} from "../../shared/dto/aps.common";
import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../http/http.service";
import AuthDataServiceName, {AuthDataService} from "../auth/authData.service";
import {Endpoints} from "../../shared/config/constant.module";
let requires = [HttpServiceName, AuthDataServiceName];

export interface CheckListsService {
  getCheckList(id: string): angular.IPromise<apsViewModels.CheckListItem>;
  getCheckListToFillOut(id: string, plantId: string, shopId: string):
    angular.IPromise<apsViewModels.CheckListItem>;
  getCheckLists(plantId: string, shopId: string, level: apsEnums.CheckListLevel, includeDeleted?: boolean):
    angular.IPromise<apsViewModels.CheckListSummary[]>;
  getCheckListsWithData(criteria: apsViewModels.CheckListDropDownCriteria):
    angular.IPromise<apsCommon.IdAndName[]>;
  addCheckList(command: apsCommands.AddCheckList): angular.IPromise<any>;
  saveCheckList(command: apsCommands.SaveCheckList): angular.IPromise<any>;
  copyCheckList(command: apsCommands.CopyCheckList): angular.IPromise<any>;
  deleteCheckList(id: string): angular.IPromise<any>;
  getCheckListMandatory(id: string, plantId: string, shopId: string):
    angular.IPromise<apsViewModels.CheckListMandatoryItem>;

  // Checks
  addCheck(command: apsCommands.AddCheckItem): angular.IPromise<any>;
  saveCheck(command: apsCommands.SaveCheckItem): angular.IPromise<any>;
  deleteCheck(command: apsCommands.DeleteCheckItem): angular.IPromise<any>;
  reorderCheck(command: apsCommands.CheckListReorder): angular.IPromise<any>;

  // overrides
  saveOverride(command: apsCommands.SaveCheckListOverride): angular.IPromise<any>;
  saveCheckOverride(command: apsCommands.SaveCheckOverride): angular.IPromise<any>;

  // reporting
  getCheckListReport(criteria: apsViewModels.CheckListReportCriteria):
    angular.IPromise<apsViewModels.CheckListReportItem[]>;
  getCheckListReportDetail(id: string, plantLocationId: string, scheduledOn: Date,
                           filter: apsEnums.CheckListReportFilter):
    angular.IPromise<apsViewModels.CheckListInstanceReportDetail>;
  getHourlyCheckReport(plantId: string,
                       wellKnownCheck: apsEnums.WellKnownCheckType,
                       numHours: number): angular.IPromise<apsViewModels.HourlyCheckReportShopItem[]>;
  getLastValue(plantId: string,
               shopId: string,
               wellKnownCheck: apsEnums.WellKnownCheckType): angular.IPromise<apsViewModels.CheckInstanceResultItem>;
  resubmitUptimeChecks(command: apsCommands.ResubmitUptimeChecks): angular.IPromise<any>;
}

export default angular
  .module('aps.services.checkLists', requires)
  .service('checkListsService', (httpService: HttpService,
                                 authDataService: AuthDataService): CheckListsService => {

    var getCheckList = (id: string) =>
      httpService
        .get<apsViewModels.CheckListItem>(Endpoints.CHECKLIST + '/' + id)
        .then((data) => {
          return data;
        });

    var getCheckListToFillOut = (id: string, plantId: string, shopId: string) =>
      httpService
        .get<apsViewModels.CheckListItem>(Endpoints.CHECKLIST + '/' + id, {plantId: plantId, shopId: shopId})
        .then((data) => {
          return data;
        });

    var getCheckLists = (plantId: string, shopId: string, level: apsEnums.CheckListLevel, includeDeleted?: boolean) =>
      httpService
        .get<apsViewModels.CheckListSummary[]>(Endpoints.CHECKLIST, {
          plantId: plantId || '',
          shopId: shopId  || '',
          level: level,
          includeDeleted: includeDeleted
        })
        .then((data) => {
          return data;
        });

    var addCheckList = (command: apsCommands.AddCheckList) =>
      httpService.post(Endpoints.CHECKLIST, command);

    var saveCheckList = (command: apsCommands.SaveCheckList) =>
      httpService.put(Endpoints.CHECKLIST, command);

    var copyCheckList = (command: apsCommands.CopyCheckList) =>
      httpService.post(Endpoints.CHECKLIST_COPY, command);

    var deleteCheckList = (id: string) =>
      httpService.delete(Endpoints.CHECKLIST + '/' + id);

    var deleteCheck = (command: apsCommands.DeleteCheckItem) =>
      httpService.delete(Endpoints.CHECK + '/' + command.id,
        { checkListId: command.checkListId });

    var addCheck = (command: apsCommands.AddCheckItem) =>
      httpService.post(Endpoints.CHECK, command);

    var saveCheck = (command: apsCommands.SaveCheckItem) =>
      httpService.put(Endpoints.CHECK, command);

    var reorderCheck = (command: apsCommands.CheckListReorder) =>
      httpService.post(Endpoints.CHECK_REORDER, command);

    var saveOverride = (command: apsCommands.SaveCheckListOverride) => {
      return httpService.post(Endpoints.CHECKLIST_OVERRIDE, command);
    };

    var saveCheckOverride = (command: apsCommands.SaveCheckOverride) => {
      return httpService.post(Endpoints.CHECK_OVERRIDE, command);
    };

    var getCheckListReport = (criteria: apsViewModels.CheckListReportCriteria) => {
      return httpService.post<apsViewModels.CheckListReportItem[]>(Endpoints.CHECKLIST_REPORT, criteria);
    };

    var getCheckListsWithData = (criteria: apsViewModels.CheckListDropDownCriteria) => {
      return httpService.post<apsCommon.IdAndName[]>(Endpoints.CHECKLIST_REPORT_LISTS, criteria);
    };

    var getCheckListReportDetail = (id: string, plantLocationId: string, scheduledOn: Date,
                                    filter: apsEnums.CheckListReportFilter) => {
      return httpService.get<apsViewModels.CheckListInstanceReportDetail>(
        Endpoints.CHECKLIST_REPORT_DETAIL + '/' + id, {
          plantLocationId: plantLocationId,
          scheduledOn: scheduledOn,
          filter: filter
        });
    };

    var getHourlyCheckReport = (plantId: string,
                                wellKnownCheck: apsEnums.WellKnownCheckType,
                                numHours: number) => {
      var params = {
        plantId: plantId,
        wellKnownCheck: wellKnownCheck,
        numHours: numHours
      };

      return httpService.get<apsViewModels.HourlyCheckReportShopItem[]>(Endpoints.CHECKLIST_REPORT_HOURLY, params);
    };

    var getLastValue = (plantId: string,
                        shopId: string,
                        wellKnownCheck: apsEnums.WellKnownCheckType) => {

      var params = {
        plantId: plantId,
        shopId: shopId,
        wellKnownCheck: wellKnownCheck
      };

      return httpService.get<apsViewModels.CheckInstanceResultItem>(Endpoints.CHECKLIST_LAST_RESULT, params);
    };

    var getCheckListMandatory = (id: string, plantId: string, shopId: string) => {
      return httpService
        .get<apsViewModels.CheckListMandatoryItem>(Endpoints.CHECKLIST_MANDATORY + '/' + id, { plantId: plantId, shopId: shopId });
    };

    var resubmitUptimeChecks = (command: apsCommands.ResubmitUptimeChecks) => {
      return httpService.post(Endpoints.CHECKLIST_RESUBMIT_TONNAGE_CHECKS, command);
    }

    return {
      getCheckList: getCheckList,
      getCheckListToFillOut: getCheckListToFillOut,
      getCheckLists: getCheckLists,
      getCheckListMandatory: getCheckListMandatory,
      addCheckList: addCheckList,
      saveCheckList: saveCheckList,
      copyCheckList: copyCheckList,
      deleteCheckList: deleteCheckList,
      addCheck: addCheck,
      saveCheck: saveCheck,
      deleteCheck: deleteCheck,
      reorderCheck: reorderCheck,
      saveOverride: saveOverride,
      getCheckListReport: getCheckListReport,
      getHourlyCheckReport: getHourlyCheckReport,
      getLastValue: getLastValue,
      saveCheckOverride: saveCheckOverride,
      getCheckListReportDetail: getCheckListReportDetail,
      getCheckListsWithData: getCheckListsWithData,
      resubmitUptimeChecks: resubmitUptimeChecks
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/checkLists/checkLists.service.ts